export const HIDDEN_COMPONENTS_IF_EMBEDDED = {
  applicationFooterNav: true,
  appLogo: true,
  sidebar: true,
  topNavigation: true,
  siteFooter: true,
  desktopHeaderNavigation: true,
  desktopHeaderCollapseNav: true
};
